'use client';

import { freddyTheme } from '@coolblue-development/freddy';
import { Checkmark, Minus } from '@coolblue-development/icons';
import type { ReactNode } from 'react';

import { StyledPropertyColumn } from './PropertyColumn.styled';

const PropertyColumn = ({ children }: { children: ReactNode }) => {
  if (children === 'true') {
    return (
      <StyledPropertyColumn>
        <Checkmark fill={freddyTheme.color.border.sentimentPositive} />
      </StyledPropertyColumn>
    );
  } else if (children === 'false') {
    return (
      <StyledPropertyColumn>
        <Minus fill={freddyTheme.color.border.interactiveControlHovered} />
      </StyledPropertyColumn>
    );
  } else {
    return <StyledPropertyColumn>{children}</StyledPropertyColumn>;
  }
};

export { PropertyColumn };
